import { render } from "./CRMWhatsappMarketingCampaingsView.vue?vue&type=template&id=172d3c81&scoped=true"
import script from "./CRMWhatsappMarketingCampaingsView.vue?vue&type=script&lang=js"
export * from "./CRMWhatsappMarketingCampaingsView.vue?vue&type=script&lang=js"

import "./CRMWhatsappMarketingCampaingsView.vue?vue&type=style&index=0&id=172d3c81&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-172d3c81"]])

export default __exports__